import { FC } from 'react';
import { tokens } from '@servicetitan/tokens';
import { BodyText, Headline, Icon, Stack } from '@servicetitan/design-system';
import { getError } from '../../utils/errors';

interface CenteredErrorProps {
    value?: Partial<Error>;
}

export const CenteredError: FC<CenteredErrorProps> = ({ value }) => {
    const error = getError(value);

    return (
        <Stack className="h-100 w-100" alignItems="center" justifyContent="center">
            <Stack
                spacing={1}
                direction="column"
                alignItems="center"
                className="ta-center"
                justifyContent="center"
            >
                <Icon name="error" size="48" color={tokens.colorRed500} />
                <Headline>{error.name}</Headline>
                <BodyText>{error.message}</BodyText>
            </Stack>
        </Stack>
    );
};
